import DateFilter from '@/components/date-filter';
import ManageDemandeAutorisation from '@/components/comptable/demande-autorisation/manage-demande-autorisation'
import store_operation from "@/store/mods/caisse/operations"
import $ from 'jquery'

export default {
    name: 'demande-autorisation',
    components: {
        DateFilter, ManageDemandeAutorisation
    },
    props: [],
    data() {
        return {
            demande_autorisations: [],
            is_empty: false,
            is_loading: true,
            is_load_error: false,

            is_month: false,
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',
            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            fields: [
                { key: 'no', label: 'N°' },
                { key: 'reference', label: 'Référence' },
                { key: 'assurance', label: 'Assurance/Société' },
                { key: 'patient', label: 'Patient' },
                { key: 'demandeur', label: 'Demandeur' },
                { key: 'date', label: 'Date demande' },
                { key: 'action', label: 'Action.s' }
            ],

            search_filter: "",
            perPage: 25,
            currentPage: 1,
            total_pages: 0,

            action_toggler: 0,
            demande_id: null,
            user_info: {}
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.current_date_filter = data
            this.is_month = true
            this.fetchDemandeAutorisation()
        },
    },
    
    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },

    mounted() {
        this.curr_month = this.monthOfYear[this.current_date.getMonth()+1]

        this.user_info = {
            name: this.userCredentials.user.name,
            user_id: this.userCredentials.user.id,
            titre: this.userCredentials.user.titre
        }
    },

    methods: {
        fetchDemandeAutorisation() {
            this.is_loading = true
            this.is_load_error = false
            store_operation.getListeDemandeAutorisation(this.current_date_filter).then((response) => {
                this.demande_autorisations = response.data
                this.total_pages = response.last_page

                if (this.demande_autorisations.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_load_error = true
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.fetchDemandeAutorisation()
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.current_date_filter.page = this.currentPage
                this.fetchDemandeAutorisation()
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.current_date_filter.page = this.currentPage
                this.fetchDemandeAutorisation()
            }
        },

        gotoPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.current_date_filter.page = this.currentPage
                this.fetchDemandeAutorisation()
            }
        },

        showDetails(data) {
            this.action_toggler = (this.action_toggler == 0)?1:0
            this.demande_id = data.id

            setTimeout(() => {
                $('.mng-demande').modal('show')
            }, 100);
        }
    }
}